"use strict";
exports.__esModule = true;
var DimensionValueState = /** @class */ (function () {
    function DimensionValueState(_a) {
        var value = _a.value, isSelected = _a.isSelected;
        var _this = this;
        this.toJSON = function () { return ({
            value: _this.value,
            isSelected: _this.isSelected
        }); };
        this.value = value;
        this.isSelected = isSelected;
    }
    DimensionValueState.fromJSON = function (json) {
        var _a = Object.assign({}, json), value = _a.value, isSelected = _a.isSelected;
        if (typeof value !== 'string')
            throw new Error('.value must be a string');
        if (typeof isSelected !== 'boolean')
            throw new Error('.isSelected must be a boolean');
        return new DimensionValueState({
            value: value,
            isSelected: isSelected
        });
    };
    return DimensionValueState;
}());
exports["default"] = DimensionValueState;
